var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoInternet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.6875V16.25",
    stroke: "#292D32",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3503 10.725V19.275C26.3503 20.675 25.6002 21.9751 24.3877 22.6876L16.9627 26.975C15.7502 27.675 14.2502 27.675 13.0252 26.975L5.6002 22.6876C4.3877 21.9876 3.6377 20.6875 3.6377 19.275V10.725C3.6377 9.32504 4.3877 8.02499 5.6002 7.31249L13.0252 3.025C14.2377 2.325 15.7377 2.325 16.9627 3.025L24.3877 7.31249C25.6002 8.02499 26.3503 9.31254 26.3503 10.725Z",
    stroke: "#292D32",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.2502V20.3752",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoInternet);
export default __webpack_public_path__ + "static/media/IconNoInternet.591b7a7d2b4fcdee9dcfef522d77df65.svg";
export { ForwardRef as ReactComponent };